<template>
  <div ref="map" style="position:relative;" v-resize:debounce="onResize"></div>
</template>

<script>
import 'vue'
import 'leaflet'
// import script after leaflet
import 'leaflet-simple-map-screenshoter'
import 'leaflet/dist/leaflet.css'
import { positionService } from './positionService'
import { mapUtils } from './mapUtils'
import resize from 'vue-resize-directive'

// import _ from 'lodash';
// import Proj4js from 'proj4';
// import 'leaflet-easybutton';
import 'leaflet-draw'
import 'leaflet-draw/dist/leaflet.draw.css'
import 'leaflet.markercluster'
import 'leaflet.markercluster/dist/leaflet.markercluster'
import 'leaflet.markercluster/dist/MarkerCluster.css'
import 'leaflet.markercluster/dist/MarkerCluster.Default.css'
import { setInterval, clearInterval, setTimeout, clearTimeout } from 'timers'
import axios from 'axios'
// Leaflet problems with marker icon
delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

// const srcPrj = new Proj4js.Proj("EPSG:900913");

export default {
  name: 'Map',
  props: {
    usecase: String,
    vehicleId: String,
    driverId: String,
    tsStart: String,
    tsEnd: String,
    authToken: String,
    apiUrl: String,
    geoFence: Array,
    refreshTimer: {
      type: Number,
      default: 0
    },
    screenShot: Boolean,
    disableSave: Boolean,
    downloadButton: Boolean
  },
  data () {
    return {
      lastPositions: [],
      assetsPositions: [],
      historyPositions: [],
      selectedPosition: undefined,
      timer: '',
      filterDelay: undefined,
      autoZoom: true,
      cancelRequest: undefined,
      simpleMapScreenshoter: null,
      savePosition: true
    }
  },
  directives: {
    resize
  },
  mounted: function () {
    // var that = this;
    // setTimeout(function(){
    //   that.map = L.map(that.$refs.map).setView([43.773, 11.256], 13);
    //   L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
    //     attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
    //   }).addTo(that.map);
    //   that.getLastPositions();
    //   that.map.on('click', function() {
    //     if (that.selectedPosition) {
    //       that.map.removeLayer(that.selectedPosition);
    //       that.selectedPosition = undefined;
    //       that.$emit('click-position', undefined);
    //     }
    //   });
    // }, 5000);
    var that = this
    that.map = L.map(that.$refs.map).setView([43.773, 11.256], 13)
    L.tileLayer('https://{s}.tile.osm.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(this.map)

    this.enablePositionMode(this.usecase)
    this.updatePositions()
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  methods: {
    onResize () {
      if (this.map) {
        this.map.invalidateSize()
      }
    },
    initCancelToken () {
      if (this.cancelRequest) {
        this.cancelRequest()
      }
      var CancelToken = axios.CancelToken
      let cancelFunction
      var ct = new CancelToken(function executor (c) {
        // An executor function receives a cancel function as a parameter
        cancelFunction = c
      })
      this.cancelRequest = cancelFunction
      return ct
    },
    validateInterval (tsStart, tsEnd) {
      if (tsStart === undefined || tsEnd === undefined) {
        this.$emit('alert-error', 'Inserire inizio e fine dell\'intervallo temporale!')
        return false
      }
      const s = parseInt(tsStart)
      if (!Number.isInteger(s) || s <= 0) {
        this.$emit('alert-error', 'Ts start non valido!')
        return false
      }
      const e = parseInt(tsEnd)
      if (!Number.isInteger(e) || e <= 0) {
        this.$emit('alert-error', 'Ts end non valido!')
        return false
      }
      if (s >= e) {
        this.$emit('alert-error', 'Intervallo non valido!')
        return false
      }
      return true
    },
    clear () {
      this.lastPositions = []
      this._posLayers = []
      this.historyPositions = []
      if (this.selectedPosition) {
        this.map.removeLayer(this.selectedPosition)
        this.selectedPosition = undefined
      }
      if (this._lastPositionsLayer) {
        this.map.removeLayer(this._lastPositionsLayer)
      }
      if (this._historyPositionsLayer) {
        this.map.removeLayer(this._historyPositionsLayer)
      }
    },
    enablePositionMode (usecase) {
      var me = this
      this.map.on('click', function () {
        if (me.selectedPosition) {
          me.map.removeLayer(me.selectedPosition)
          me.selectedPosition = undefined
          me.$emit('click-position', undefined, undefined)
        }
      })
      if (usecase === 'realtime' && this.refreshTimer > 0 && !this.timer) {
        this.timer = setInterval(function () {
          me.updatePositions(usecase, true)
        }, this.refreshTimer)
      } else {
        if (this.timer) {
          clearInterval(this.timer)
        }
      }
    },
    disablePositionMode () {
      this.map.off('click')
      if (this.timer) {
        clearInterval(this.timer)
      }
      this.clear()
    },
    enableDrawMode () {
      this.drawGeometry(undefined, false)
    },
    disableDrawMode () {
      if (this.drawnItems) {
        this.map.removeLayer(this.drawnItems)
        this.drawnItems = undefined
      }
      if (this.drawControl) {
        this.map.removeControl(this.drawControl)
      }
      this.map.off('draw:created')
      this.map.off('draw:edited')
    },
    initMapUsecase (usecase) {
      const uc = usecase || this.usecase
      if (uc === 'realtime' || uc === 'history') {
        this.disableDrawMode()
        this.enablePositionMode(uc)
        this.updatePositions(uc, false)
      } else if (uc === 'drawalarm') {
        this.disablePositionMode()
        // enabling draw mode
        this.enableDrawMode()
      } else {
        this.$emit('alert-error', 'usecase non valido [\'realtime\'|\'history\'|\'drawalarm\']')
      }
    },
    refresh (autoZoom) {
      this.updatePositions(this.usecase, !autoZoom)
    },
    refreshWithDelay () {
      if (this.filterDelay) {
        clearTimeout(this.filterDelay)
      }
      var t = this
      this.filterDelay = setTimeout(function () {
        t.updatePositions(this.usecase, false)
      }, 1000)
    },
    updatePositions (usecase, fromTimer) {
      // this.autoZoom = (autoZoom != undefined) ? autoZoom : true;
      const uc = usecase || this.usecase
      if (uc === 'realtime') {
        this.autoZoom = !fromTimer
        this.getLastPositions()
      } else if (uc === 'history') {
        this.getPositions()
      }
    },
    drawGeometry (geometry, edit) {
      if (this.drawnItems) {
        this.map.removeLayer(this.drawnItems)
        this.drawnItems = undefined
      }
      if (this.drawControl) {
        this.map.removeControl(this.drawControl)
      }
      if (this.usecase === 'drawalarm') {
        var layers = []
        if (geometry && geometry.type && geometry.type === 'MultiPolygon') {
          geometry.coordinates.forEach(polygon => {
            layers.push(L.GeoJSON.geometryToLayer({
              type: 'Polygon',
              coordinates: polygon
            }))
          })
        }
        this.drawnItems = new L.FeatureGroup(layers)
        this.map.addLayer(this.drawnItems)
        this.drawnItems.on('layeradd', this.updateGeometry, this)
        this.drawnItems.on('layerremove', this.updateGeometry, this)
        this.map.on('draw:created', function (e) {
          var layer = e.layer
          this.drawnItems.addLayer(layer)
        }, this)
        this.map.on('draw:edited', this.updateGeometry, this)
        if (layers.length > 0) {
          this.map.fitBounds(this.drawnItems.getBounds())
        }
        if (edit) {
          this.addDrawControl()
        }
      }
    },
    addDrawControl () {
      this.drawControl = new L.Control.Draw({
        draw: {
          polyline: false,
          rectangle: false,
          circle: false,
          marker: false,
          circlemarker: false,
          polygon: {
            allowIntersection: false
          }
        },
        edit: {
          featureGroup: this.drawnItems
        }
      })
      this.map.addControl(this.drawControl)
    },
    updateGeometry () {
      var multiPolygonLatLng = []
      this.drawnItems.eachLayer(function (layer) {
        multiPolygonLatLng.push(layer.toGeoJSON().geometry.coordinates)
      })
      if (multiPolygonLatLng.length) {
        var multiPolygon = {
          type: 'Feature',
          geometry: {
            type: 'MultiPolygon',
            coordinates: multiPolygonLatLng
          }
        }
        // eslint-disable-next-line
        // console.log(JSON.stringify(multiPolygon.geometry));
        this.$emit('update-geometry', multiPolygon.geometry)
      } else {
        this.$emit('update-geometry', undefined)
      }
    },
    getLastPositions () {
      this.clear()
      var ct = this.initCancelToken()
      positionService.getLastPositions(ct, this.apiUrl, this.authToken, this.vehicleId, this.driverId)
        .then(
          positions => {
            this.lastPositions = positions
          },
          error => {
            if (error) this.$emit('alert-error', error)
          }
        )
    },
    getPositions () {
      this.clear()
      if (this.vehicleId === undefined && this.driverId === undefined) {
        this.$emit('alert-error', 'Selezionare almeno un veicolo o un autista!')
        return
      }
      if (!this.validateInterval(this.tsStart, this.tsEnd)) {
        return
      }
      // let end = 1559818119;
      // let start = end - (3*60*60);
      // get standard and stop positions, then combines to one pos layer.
      var ct = this.initCancelToken()
      positionService.getPositions(ct, this.apiUrl, this.authToken, this.vehicleId, this.driverId, this.tsStart, this.tsEnd)
        .then(
          positions => {
            var allPositions = positions
            positionService.getStopPositions(ct, this.apiUrl, this.authToken, this.vehicleId, this.driverId, this.tsStart, this.tsEnd)
              .then(
                positions => {
                  var stopPositions = positions
                  this.mergeStopPosition(allPositions, stopPositions)
                },
                error => {
                  if (error) this.$emit('alert-error', error)
                }
              )
          },
          error => {
            this.clear()
            if (error) this.$emit('alert-error', error)
          }
        )
    },
    selectPosition (position) {
      if (this.usecase === 'history') {
        this.selectedPosition = mapUtils.setSingleMarker(this.map, this.selectedPosition, position)
        return this.selectedPosition
      }
    },
    mergeStopPosition (allPositions, stopPositions) {
      var that = this
      if (allPositions.length === 0 && stopPositions.length === 0) {
        this.$emit('loaded-positions', [])
        return
      }
      var mergedPositions = []
      allPositions.sort().forEach(p => {
        const ts = p.properties.ts
        var isStop = false
        for (var i = 0; i < stopPositions.length; i++) {
          if (ts >= stopPositions[i].properties.ts) {
            if (ts <= (stopPositions[i].properties.ts + stopPositions[i].properties.stopDuration)) {
              isStop = true
            }
            if (ts === stopPositions[i].properties.ts) {
              mergedPositions.push(stopPositions[i])
            }
          }
        }
        if (!isStop) {
          mergedPositions.push(p)
        }
      })
      this.historyPositions = mergedPositions

      var clickHandler = function (f) {
        that.selectedPosition = mapUtils.setSingleMarker(that.map, that.selectedPosition, f)
        that.$emit('click-position', f, that.selectedPosition)
      }
      this._historyPositionsLayer = mapUtils.getHistoryPositionsLayer(mergedPositions, this._posLayers, this.map, clickHandler)
    },
    takeScreenshot () {
      const simpleMapScreenshoter = L.simpleMapScreenshoter({ hidden: true }).addTo(this.map)
      simpleMapScreenshoter.takeScreen('image', {}).then(blob => {
        this.$emit('put-verification', blob)
      }).catch(e => {
        alert(e.toString())
      })
    }
  },
  watch: {
    usecase: function (val) {
      this.initMapUsecase(val)
    },
    vehicleId: function () {
      this.refreshWithDelay()
    },
    driverId: function () {
      this.refreshWithDelay()
    },
    tsStart: function () {
      this.refreshWithDelay()
    },
    tsEnd: function () {
      this.refreshWithDelay()
    },
    refreshTimer: function (val) {
      var me = this
      if (this.usecase === 'realtime' && this.timer) {
        clearInterval(this.timer)
        this.timer = setInterval(function () {
          me.updatePositions(me.usecase, true)
        }, val)
      } else {
        if (this.timer) {
          clearInterval(this.timer)
        }
      }
    },
    historyPositions: function (val, oldVal) {
      // if (val.length === oldVal.length && val.every(function(value, index) { return value === oldVal[index]})) {
      //   // eslint-disable-next-line
      //   console.log("array are equals!",oldVal, val);
      // } else {
      //   this.$emit('loaded-positions', val);
      // }
      if (!(val.length === oldVal.length && val.every(function (value, index) {
        return value === oldVal[index]
      }))) {
        this.$emit('loaded-positions', val)
      }
    },
    lastPositions: function (val) {
      var that = this
      var clickHandler = function (f) {
        that.selectedPosition = mapUtils.setSingleMarker(that.map, that.selectedPosition, f)
        that.$emit('click-position', f, that.selectedPosition)
      }
      this._lastPositionsLayer = mapUtils.getLastPositionsLayer(val, this.map, clickHandler, this.autoZoom)
    }
  }
}

</script>

<style>
.stop {
  background-image: url('./stop.png');
  /* z-index: 9900 !important; */
}

.marker-arrow {
  margin-left: 0 !important;
  margin-top: 0 !important;
  background-image: url('./arrow.png');
  background-color: transparent !important;
  background-size: 30px 30px;
  position: absolute;
}

.marker-cluster-0 div {
  background-color: rgba(255, 255, 255, 0.7);
}

.marker-cluster-1 {
  background-color: rgba(181, 226, 140, 0.6);
}

.marker-cluster-1 div {
  background-color: rgba(110, 204, 57, 0.6);
}

.marker-cluster-2 {
  background-color: rgba(241, 211, 87, 0.6);
}

.marker-cluster-2 div {
  background-color: rgba(240, 194, 12, 0.6);
}

.marker-cluster-3 {
  background-color: rgba(253, 156, 115, 0.6);
}

.marker-cluster-3 div {
  background-color: rgba(241, 128, 23, 0.6);
}

.marker-cluster-4 {
  background-color: rgba(125, 215, 255, 0.4);
}

.marker-cluster-4 div {
  background-color: rgba(125, 215, 255, 0.7);
}

.marker-cluster-5 {
  background-color: rgba(96, 125, 139, 0.4);
}

.marker-cluster-5 div {
  background-color: rgba(96, 125, 139, 0.7);
}

.marker-cluster-6 {
  background-color: rgba(58, 164, 255, 0.4);
}

.marker-cluster-6 div {
  background-color: rgba(58, 164, 255, 0.7);
}

.leaflet-container {
  height: 90%;
  width: 100%;
  position: sticky !important;
  z-index: 0 !important;
}
</style>
